/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseProjectGroupDtoPage } from '../../models/base-project-group-dto-page';

export interface ListProjectGroups$Params {
  id: string;
  memberId?: string | null;
  query?: string;
  roleIds?: Array<string>;
  canAssignWorkPackage?: boolean | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'groupName' | '-groupName' | 'memberships' | '-memberships'>;
}

export function listProjectGroups(http: HttpClient, rootUrl: string, params: ListProjectGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseProjectGroupDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listProjectGroups.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('memberId', params.memberId, {});
    rb.query('query', params.query, {});
    rb.query('roleIds', params.roleIds, {});
    rb.query('canAssignWorkPackage', params.canAssignWorkPackage, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseProjectGroupDtoPage>;
    })
  );
}

listProjectGroups.PATH = '/v0/projects/{id}/groups';
